import { createStandaloneToast } from "@chakra-ui/react";

export type MutateErrors = {
	response: {
		data: {
			errors: {
				field: string;
				message: string;
			}[];
		};
	};
};

export const mutateOnError = (err: MutateErrors) => {
	const { toast } = createStandaloneToast();
	err.response.data.errors.forEach((error) => {
		toast({
			title: "Erreur",
			description: error.message,
			status: "error",
			duration: 5000,
			isClosable: true,
		});
	});
};
